import React, { useState } from "react";
import { CommonHeader } from "../../../components/commons";
import PendingLeaves from "../../../components/MySpace/AllLeaves/manager/PendingLeaves";
import ApprovedLeaves from "../../../components/MySpace/AllLeaves/manager/ApprovedLeaves";

interface TabsType {
  name: string;
  label: string;
  display: boolean | undefined;
}
const tabs: TabsType[] = [
  {
    name: "Pending Leave Requests",
    label: "Pending Leaves",
    display: true,
  },
  {
    name: "Approved Leave Requests",
    label: "Approved Leaves",
    display: true,
  },
];

type AppProps = {
  history: any;
};
const ApprovedAndPendingLeaves = ({ history }: AppProps) => {
  const [activeTab, setActiveTab] = useState(tabs[0].label);

  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };
  const renderTabs = () => {
    let finalTab = tabs.map((tab: TabsType) => {
      return (
        <div
          className={tab.display ? "tab-style mr-4" : ""}
          key={tab.label}
          onClick={() => {
            handleTabChange(tab.label);
          }}
        >
          {tab.display && (
            <div
              style={{
                padding: "12px 5px 12px 5px",
                color: activeTab === tab.label ? "#dd4433" : "",
                fontSize: "14px",
              }}
              className={`tab-header ${
                activeTab === tab.label ? "active" : ""
              }`}
            >
              {tab.name}
            </div>
          )}
          <div
            className={`${
              activeTab === tab.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });

    return finalTab;
  };
  return (
    <>
      <div className="col-md-6">
        <CommonHeader title="Pending Leave" />
      </div>
      <div className="boxs mt-4">
        {/* <div className="col-md-12"> */}
        <div
          className="d-flex align-items-center"
          style={{ justifyContent: "space-between" }}
        >
          <div className="col-md-12 p-0 ">
            <div
              style={{
                background: "#d8dee4",
                borderRadius: "5px 5px 0 0",
                padding: "0px 15px",
              }}
            >
              <div className="d-flex">{renderTabs()}</div>
            </div>
          </div>
          {/* </div> */}
        </div>
        {activeTab === "Pending Leaves" && <PendingLeaves history={history} />}
        {activeTab === "Approved Leaves" && <ApprovedLeaves />}
      </div>
    </>
  );
};

export default ApprovedAndPendingLeaves;
